module.exports = __webpack_public_path__ + "img/quickResponseMechanism.818fdd4d.svg";